<template>
  <div class="zyc-note">
    <div class="zyc-note-t-l"></div>
    <div class="zyc-note-t-r"></div>
    <div class="zyc-note-b-l"></div>
    <div class="zyc-note-b-r"></div>
    <slot></slot>
    <div style="clear:both"></div>
  </div>
</template>
<script>
  /**
  * 注释容器
  */
  export default {
    name: 'zycNote',
    props: {
    },
    model: {
    },
    watch: {
    },
    data() {
      return {
      }
    },
    mounted() {
      
    },
    created() {
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/zyc/container/noteContainer.vue